import { dispatch, useAppSelector, type RootState } from 'api/redux'
import { setKeyboardWithClosureOpen } from 'api/redux/store/application.actions'
import { useEffect, useState } from 'react'

import { AlphaNumeric, NumPad } from '.'
import './VirtualKeyboard.css'

interface KeyboardProps {
  text: string
  setText: (value: string) => void
  confirm: () => void
  className?: string
  whichKeyboard: string
  heightIconDiv?: string
  canCloseKeyboard?: boolean
  showPunctuationMarks?: boolean
}

const applicationSelector = (state: RootState) => state.application.isKeyboardOpenWithClosure

export const VirtualKeyboard = ({
  text,
  setText,
  className,
  confirm,
  whichKeyboard,
  heightIconDiv,
  canCloseKeyboard,
  showPunctuationMarks
}: KeyboardProps) => {
  const keyboardComponentVisible: boolean = process.env.REACT_APP_KEYBOARD_COMPONENT_VISIBLE === 'true'

  const isKeyboardOpenWithClosure = useAppSelector(applicationSelector)

  const [showOnScreenKeyboard, setShowOnScreenKeyboard] = useState(canCloseKeyboard ? isKeyboardOpenWithClosure : false)

  useEffect(() => {
    if (canCloseKeyboard) dispatch(setKeyboardWithClosureOpen(showOnScreenKeyboard))
  }, [showOnScreenKeyboard])

  if (!keyboardComponentVisible) {
    return null
  }
  if (!showOnScreenKeyboard) {
    const iconPath = `/images/${whichKeyboard === 'alphanumeric' ? 'keyboard' : 'numpad'}-icon.svg`
    return (
      <div style={{ height: heightIconDiv ?? '400px' }} className={`flex justify-center ${className ?? ''} ${canCloseKeyboard ? 'animated fadeInBottom' : ''}`} onClick={() => { setShowOnScreenKeyboard(true) }}>
        <img height={'80'} width={'80'} alt={'Keypad icon'}
          src={iconPath}
          className={'keyboard-icon mb-24'} />
      </div>
    )
  }

  return (
    <div className='flex flex-col'>
      {whichKeyboard === 'alphanumeric'
        ? (
          <AlphaNumeric text={text} setText={setText} confirm={confirm} className={className} showPunctuationMarks={showPunctuationMarks} />
          )
        : (
          <NumPad text={text} setText={setText} confirm={confirm} className={className} />
          )
      }
      {canCloseKeyboard === true &&
        <img height={'60'} width={'60'} alt={'Close Keyboard icon'}
          src='/images/close-keyboard-icon.svg'
          className={'keyboard-icon hide-keyboard-icon'} onClick={() => { setShowOnScreenKeyboard(false) }} />
      }
    </div>
  )
}
